import useScrollReset from 'src/hooks/useScrollReset';

const ScrollReset = ({ scrollRef }) => {
  useScrollReset(scrollRef);

  return null;
};

export default ScrollReset;
